import React from "react";
import { useTranslation } from "react-i18next";

/** The fallback route (7HAI-1704): speaks the UI language like everything else. */
const NotFound: React.FC = () => {
  const { t } = useTranslation();
  return <h1>{t("sharedUi.pageNotFound")}</h1>;
};

export default NotFound;
